import TextButton from '@/components/atoms/TextButton/TextButton';
import Image from 'next/image';
import { ReactNode } from 'react';

export const PromoAndSteps = ({
  handleScrollToVin,
}: {
  handleScrollToVin: () => void;
}) => {
  const REGISTRATION_STEPS: {
    image: {
      src: string;
    };
    title: string;
    description: ReactNode;
  }[] = [
    {
      image: {
        src: '/images/sell-my-car/step-1.svg',
      },
      title: 'Tell us about your vehicle',
      description: 'Enter the information and condition.',
    },
    {
      image: {
        src: '/images/sell-my-car/step-2.svg',
      },
      title: 'Take photos',
      description: 'Upload images of your vehicle to get a valuation.',
    },
    {
      image: {
        src: '/images/sell-my-car/step-3.svg',
      },
      title: 'Get offers from trusted dealers',
      description: (
        <>
          Negotiate a sale price with the dealer to get cash or trade in your
          vehicle.{' '}
          <TextButton aria-label="get started" onClick={handleScrollToVin}>
            Get Started
          </TextButton>
        </>
      ),
    },
  ];
  return (
    <div className="!ml:px-l flex flex-col gap-l bg-neutral-100 py-[40px] ml:py-[60px]">
      <div className="flex flex-col gap-l p-l ml:px-[60px] ml:py-[20px] l:flex-row">
        <div className="flex max-h-[604px] basis-1/2 flex-row justify-between rounded-small border-[1px] border-neutral-200 bg-blue-light">
          <div className="flex flex-1 basis-1/2 flex-col justify-between p-2xl ml:pb-2xl">
            <div className="mb-l flex flex-col gap-l ml:mb-0">
              <h2 className="text-h2SemiBold">Dealers will buy your car</h2>
              <p>
                Our network of trusted dealers are ready to buy your EV, gas, or
                plug-in hybrid car.
              </p>
            </div>
          </div>
          <div className="hidden flex-initial ml:flex">
            <Image
              src="/images/sell-my-car/used-car-collage.webp"
              width={290}
              height={283}
              alt="A collage of images of 2 used Fords and a Mercedes, arranged like a scrapbook"
              className="h-[293px] w-[290px]"
            />
          </div>
        </div>
        <div className="flex max-h-[604px] basis-1/2 flex-col gap-l rounded-small bg-brandMidnight p-2xl ml:flex-row ml:justify-between">
          <div className="flex flex-col justify-between">
            <div className="flex flex-col gap-l">
              <h2 className="text-h2SemiBold text-white">Free valuation</h2>
              <p className="text-white">
                Get a no-obligation quote to find out what your car is worth.
              </p>
            </div>
          </div>
          <div className="flex w-full basis-1/2 flex-col justify-end gap-s">
            <Image
              src="/images/sell-my-car/free-valuation.svg"
              width={191}
              height={308}
              alt="A car and a price tag"
              className="ml:w-full"
            />
          </div>
        </div>
      </div>
      <div className="py-l pl-l pr-0 ml:px-[60px] ml:py-[20px]">
        <div className="flex flex-1 flex-col rounded-medium bg-white p-l">
          <div className="mb-m ml:mb-l">
            <h3 className="text-h3SemiBold ml:hidden">How it works</h3>
            <h3 className="hidden text-h3SemiBold ml:block">
              Quick and easy process
            </h3>
          </div>
          <div className="flex flex-row gap-[20px] overflow-x-scroll ml:justify-between">
            {REGISTRATION_STEPS.map(({ image, title, description }, index) => (
              <div
                key={`REGISTRATION_STEPS-${index}`}
                className="flex min-w-[248px] flex-1 flex-col items-start gap-m ml:max-w-[416px]"
              >
                <div className="relative flex h-[155px] w-full items-center justify-center ml:h-[260px]">
                  <Image src={image.src} fill alt={title} />
                </div>
                <p className="text-body1Medium">{title}</p>
                <p className="text-body2Light">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
